import { Button } from '@components/primitives/Button';
import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { useCanManagePatientFinancials } from '@features/billing/permissions/useCanManagePatientFinancials';
import { useRequestPayment } from '@features/payments';
import { useEventTracking } from '@services/statsig';
import { publicAsset } from '@utils/publicAsset';

import { CardImg } from './shared/CardImg';
import { Chip } from './shared/Chip';

/**
 * RequestPaymentCard Component
 * Dashboard card for requesting payments from patients
 */
export const RequestPaymentCard = () => {
  const canManagePatientFinancials = useCanManagePatientFinancials();
  const { dashboard } = useEventTracking();
  const { triggerPaymentRequest } = useRequestPayment({
    source: 'request_payment_card',
  });

  const handleClick = () => {
    dashboard.actionClicked({
      action_type: 'request_payment',
      source: 'dashboard_v2_card',
    });
    triggerPaymentRequest();
  };

  // The whole card is the verb (gdn-3287) — there is no non-money part
  // to keep, and the sheet's own reads carry the same guard, so offering
  // it would fail on open.
  if (!canManagePatientFinancials) return null;

  return (
    <FeatureCard
      title="Collect payment"
      badge={<Chip label="New" />}
      onClick={handleClick}
      fullHeight
      action={<Button variant="outlined">Collect payment</Button>}
    >
      <CardImg src={publicAsset('/dashboard/home-tile_request-payment.png')} alt="Collect payment" />
    </FeatureCard>
  );
};

export default RequestPaymentCard;
